import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

// import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { SharedModule } from '@app-shared/shared.module';

import { AuthenticationRoutingModule } from './authentication-routing.module';
import { AdminLoginComponent } from './pages/admin-login/admin-login.component';
import { FleetManagerLoginComponent } from './pages/fleet-manager-login/fleet-manager-login.component';
import { MasterLoginComponent } from './pages/master-login/master-login.component';
import { LandingPageComponent } from './pages/landing-page/landing-page.component';
import { EulaComponent } from './pages/eula/eula.component';
import { EulaDocumentComponent } from './pages/eula-document/eula-document.component';
import { CustomLoginComponent } from './pages/custom-login/custom-login.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { RedirectionComponent } from './pages/redirection/redirection.component';
import { LogoutComponent } from './pages/logout/logout.component';

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}

@NgModule({
  imports: [
    CommonModule,
    AuthenticationRoutingModule,
    TranslateModule,
    SharedModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  declarations: [
    MasterLoginComponent,
    FleetManagerLoginComponent,
    AdminLoginComponent,
    LandingPageComponent,
    EulaComponent,
    EulaDocumentComponent,
    CustomLoginComponent,
    RedirectionComponent,
    LogoutComponent,
  ],
  exports: [EulaDocumentComponent],
  entryComponents: [EulaComponent],
})
export class AuthenticationModule {}
